import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"start"}/>
}
